import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp7-dumbledores-dark-secrets-revealed",
  name: `The Daily Prophet\n'Dumbledore's Dark Secrets Revealed'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Dumbledore's Dark Secrets Revealed'",
  },
  origin: "Harry Potter and the Deathly Hallows",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
